import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

import {Groups} from "@/types/Order";
import {computed} from "vue";
import {useGlobalSetting} from "@/lib/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupSelect',
  props: /*@__PURE__*/_mergeModels({
  variant: {
    type: String,
    default: "outlined"
  },
  maxPermission: {
    type: Number,
    default: 1
  },
  minPermission: {
    type: Number,
    default: 0
  },
  required: {
    type: Boolean,
    default: false
  },
  rules: {
    type: Array,
    default: () => []
  }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const selected = _useModel(__props, "modelValue")

const props = __props

const rules = computed(() => props.rules)

const items = computed(() => Object.values(Groups));

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    modelValue: selected.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
    items: items.value,
    variant: _unref(useGlobalSetting)().globalTextVariant,
    rules: rules.value,
    "item-title": "displayName",
    "item-value": "name",
    label: "Gruppe"
  }, {
    "prepend-item": _withCtx(() => [
      _createVNode(_component_v_list_item_title, { class: "text-center font-weight-bold" }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Auswahl der Gruppe ")
        ])),
        _: 1,
        __: [1]
      }),
      _createVNode(_component_v_divider)
    ]),
    item: _withCtx(({ props, item }) => [
      (item.raw.permission <= __props.maxPermission && item.raw.permission >= __props.minPermission)
        ? (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({
            key: 0,
            subtitle: item.raw.name,
            title: item.raw.displayName
          }, props), {
            prepend: _withCtx(() => [
              _createVNode(_component_v_avatar, {
                class: _normalizeClass(item.raw.color)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.raw.icon), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class"])
            ]),
            _: 2
          }, 1040, ["subtitle", "title"]))
        : _createCommentVNode("", true)
    ]),
    selection: _withCtx(({ item }) => [
      _createVNode(_component_v_avatar, {
        class: _normalizeClass(`${item.raw.color} mr-2`),
        size: "25"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            class: "pa-0 mr-0",
            size: "18"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.raw.icon), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["class"]),
      _createElementVNode("span", null, _toDisplayString(item.raw.displayName), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "items", "variant", "rules"]))
}
}

})